import { Field } from 'redux-form';
import NumberInput from './NumberInput.js';

const NumberField = (props) => {
  return (
    <div>
      <Field
        id={props.id}
        name={props.name}
        typeName={props.typeName}
        order={props.order}
        required={props.required}
        values={props.options}
        component={NumberInput}
      />
    </div>);
}

export default NumberField;